module.exports = __webpack_public_path__ + "img/miniprogramcode.7c035335.jpg";